// Import from NPM
// -------------------------------------
import React from "react";
import Countdown from "@components/Countdown.react";

import { Div } from "@components/Generics.react";
import "@styles/navbars.scss";
// import { Modal } from "semantic-ui-react";
export default function SimTimer(props) {
    const { maxTime = 14400 } = props;
    // const savedTime = parseInt(localStorage.getItem(`timer-x1we4213`), 0);
    // const [showStartModal, setShowStartModal] = useState(
    //     savedTime > maxTime - 120
    // );
    // const [showEndModal, setShowEndModal] = useState(savedTime <= 0);

    // useEffect(() => {
    //     if (savedTime <= 0) {
    //         setShowEndModal(true);
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [savedTime]);
    // ========================= Render Function =================================
    return (
        <Div className={`quick-menu vertical`}>
            <Div flex spaceBetween wd={"calc(100% - 35px)"}>
                <Div wd="80px">OVERALL TIME LEFT</Div>
                {/* {!showStartModal && ( */}
                <Countdown
                    initialSeconds={maxTime}
                    color={"#ffffff"}
                    showMinutes
                    localStore={"x1we4213"}
                    // onZero={() => setShowEndModal(true)}
                />
                {/* )} */}
                {/* <Modal
                    size="small"
                    dimmer="blurring"
                    open={showStartModal}
                    closeOnEscape={false}
                    closeOnDimmerClick={false}
                >
                    <Modal.Content>
                        <Div center-aligned>
                            <Div massive bold basepad uppercase>
                                Are your ready?
                            </Div>
                            <Div fluid flex spaceBetween>
                                <Div fluid medpad left-align>
                                    <Div fluid flex spaceBetween gutter>
                                        {showStartModal && (
                                            <Countdown
                                                initialSeconds={maxTime}
                                                color={"#ffffff"}
                                                showMinutes
                                                localStore={"x1we4213"}
                                            />
                                        )}
                                        <Div wd="calc(100% - 110px)">
                                            Welcome! Your timer has started. You
                                            have a total of 4:00 hours to
                                            complete the simulation. Your timer
                                            will always be visible on the left
                                            of the screen. Make sure to keep an
                                            eye on it.
                                        </Div>
                                    </Div>
                                    A few things to keep in mind:
                                    <ul>
                                        <li>
                                            Play this on a Chrome browser for
                                            the best results.
                                        </li>
                                        <li>
                                            Ensure that your browser
                                            maginification is set to 100% as
                                            other settings may affect how the
                                            simulation looks. You can do this by
                                            pressing Ctrl+zero on your keyboard.
                                        </li>
                                        <li>
                                            The timer continues to run even if
                                            you navigate off this window/tab, or
                                            close the browser. Once started,
                                            your timer cannot be reset.
                                        </li>
                                        <li>
                                            While the system does not block you
                                            from continuing to play beyond this
                                            timer, you can be penalized in your
                                            evaluation if you exceed the
                                            stipulated time.
                                        </li>
                                        <li>
                                            Do not open the simulation on
                                            multiple tabs at the same time as
                                            that can cause data inconsistencies
                                        </li>
                                        <li>
                                            Do not clear cache or reset your
                                            browser/simulation settings, since
                                            that may be considered an integrity
                                            violation and can be grounds for
                                            disqualification from the process.
                                            If you need to do so for any reason,
                                            please connect with the helpdesk
                                            before you do so.
                                        </li>
                                        <li>
                                            We are always watching, and always
                                            there to help. Don't hesitate to
                                            drop us a line.
                                        </li>
                                    </ul>
                                    And now, whenever you are ready...
                                </Div>
                            </Div>
                        </Div>
                    </Modal.Content>
                    <Modal.Actions>
                        <Div fluid center-aligned>
                            <Button
                                primary
                                large={+true}
                                content="Let's Start!"
                                onClick={() => {
                                    setShowStartModal(false);
                                }}
                            />
                        </Div>
                    </Modal.Actions>
                </Modal>
                <Modal
                    size="small"
                    dimmer="blurring"
                    open={showEndModal}
                    closeOnEscape={false}
                    closeOnDimmerClick={false}
                >
                    <Modal.Content>
                        <Div center-aligned>
                            <Div massive bold basepad uppercase>
                                Time's Up
                            </Div>
                            <Div fluid flex spaceBetween large>
                                You've come to the end of the designated time
                                allocation. You're in the penalty zone, so
                                please hurry up and finish...
                            </Div>
                        </Div>
                    </Modal.Content>
                    <Modal.Actions>
                        <Div fluid center-aligned>
                            <Button
                                primary
                                content="Continue"
                                onClick={() => {
                                    setShowEndModal(false);
                                }}
                            />
                        </Div>
                    </Modal.Actions>
                </Modal> */}
            </Div>
        </Div>
    );
}
